import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { RouterLink } from '@angular/router';
import { CompanyTableComponent } from '../../components/company-table/company-table.component';
import { Permission } from '@shared/enums/permission.enum';
import { SharedMaterialUIModule } from '@shared/modules/shared-material-ui.module';
import { PermissionService } from '@core/services/permission.service';
import { CompanyResponse } from '../../company.model';
import { CompanyStore } from '../../company.store';
import {SHARED_IMPORTS} from "../../../../shared/modules/shared-imports.module";

@Component({
  selector: 'app-company-list-page',
  imports: [RouterLink, CompanyTableComponent, ...SharedMaterialUIModule, ...SHARED_IMPORTS],
  templateUrl: './company-list.page.html',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class CompanyListPage {
  private readonly permissionService = inject(PermissionService);

  protected readonly companyStore = inject(CompanyStore);
  protected readonly actionCompanyId = signal<string | null>(null);

  constructor() {
    this.companyStore.loadCompanies();
  }

  protected canCreate(): boolean {
    return this.permissionService.hasPermission(Permission.CompaniesCreate);
  }

  protected canUpdate(): boolean {
    return this.permissionService.hasPermission(Permission.CompaniesUpdate);
  }

  protected canDeactivate(): boolean {
    return this.permissionService.hasPermission(Permission.CompaniesDelete);
  }

  protected canActivate(): boolean {
    return this.permissionService.hasPermission(Permission.CompaniesUpdate);
  }

  protected toggleCompanyActive(company: CompanyResponse): void {
    this.actionCompanyId.set(company.id);

    const complete = () => {
      this.companyStore.loadCompanies();
      this.actionCompanyId.set(null);
    };

    if (company.isActive) {
      if (!this.canDeactivate()) {
        this.actionCompanyId.set(null);
        return;
      }

      this.companyStore.deactivateCompany(company.id, complete);
      return;
    }

    if (!this.canActivate()) {
      this.actionCompanyId.set(null);
      return;
    }

    this.companyStore.activateCompany(company.id, complete);
  }
}